// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFunctions, httpsCallable } from "firebase/functions";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCpOn-KfxHa5yagzAIXgL77KTzH8-BEMnc",
    authDomain: "minneai.firebaseapp.com",
    projectId: "minneai",
    storageBucket: "minneai.firebasestorage.app",
    messagingSenderId: "53281561152",
    appId: "1:53281561152:web:32619857ea240766a1dda5",
    measurementId: "G-LTC81SF6BD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// App Check (reCAPTCHA v3) loads ~350 KB of script, so it is set up only when
// something that needs it is about to run: the contact form and the chat. Both
// await ensureAppCheck() before their first request.
let appCheckReady;
export const ensureAppCheck = () => {
    if (!appCheckReady) {
        appCheckReady = import('firebase/app-check').then(({ initializeAppCheck, ReCaptchaV3Provider }) =>
            initializeAppCheck(app, {
                provider: new ReCaptchaV3Provider('6LfYq1MrAAAAAJiyaalxBIFKRo3HR96R42tq2azN'),
                isTokenAutoRefreshEnabled: true,
            }));
    }
    return appCheckReady;
};

// Firestore is ~100 KB gzipped and only the contact form writes to it, so it
// loads with that page's submit rather than on every visit.
export const getDb = () => import('firebase/firestore').then((m) => ({ db: m.getFirestore(app), ...m }));

const functions = getFunctions(app);

export { app };
export const handleSubmission = httpsCallable(functions, "handleSubmission");